import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// DESIGN.md section 15: small restrained pills, 12px medium, coloured text on
// its own soft ground. Never a button.
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[12px] font-medium leading-[18px] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'border-input text-foreground',
        success: 'border-transparent bg-success-soft text-[#166549] dark:text-brand-300',
        warning: 'border-transparent bg-warning-soft text-[#8A6515] dark:text-amber-300',
        info: 'border-transparent bg-info-soft text-[#5E4AA3] dark:text-violet-300',
        danger: 'border-transparent bg-destructive-soft text-[#9B403B] dark:text-rose-300',
        soft: 'border-transparent bg-primary-soft text-primary',
        muted: 'border-transparent bg-muted text-muted-foreground',
        peach: 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
        rose: 'border-transparent bg-destructive-soft text-[#9B403B] dark:text-rose-300',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
